import LeaveCSVPreviewHeader from './LeaveCSVPreviewHeader'
import {ReportGroupingLevel} from '../../../constants'
import {LeaveTypeColumnConfig} from '../../../leavesReport/LeaveReportConfig'
import LeaveCSVPreviewGroupingSection from './LeaveCSVPreviewGroupingSection'
import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import LeaveCSVPreviewTimeAndBalancesStrategy from './LeaveCSVPreviewTimeAndBalancesStrategy'
import LeaveCSVPreviewBalancesOnlyStrategy from './LeaveCSVPreviewBalancesOnlyStrategy'
import LeaveCSVPreviewLeaveTimeOnlyStrategy from './LeaveCSVPreviewTimeOnlyStrategy'

export default function LeaveCSVPreviewGenerator() {}
LeaveCSVPreviewGenerator.prototype.init = function(){
    return this;
};

LeaveCSVPreviewGenerator.NUM_OF_DATA_COLUMNS = 10; // (o/u reported by user, o/u auto calculated, working time, leave time)

LeaveCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder) {

    let numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels( [
                                                                           reportParameters.firstGroupingLevel,
                                                                           reportParameters.secondGroupingLevel
                                                                       ] );
    let columnsStrategy = this.createPreviewStrategy( reportParameters )
    let totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns()
    let header = new LeaveCSVPreviewHeader().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            columnsStrategy,
            numOfGroupingColumns,
            reportParameters.columnsConfig
    );

    let dataGroupingSection = new LeaveCSVPreviewGroupingSection().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            columnsStrategy,
            numOfGroupingColumns,
            columnsStrategy.getNumOfDataColumns()
    );

    let table = document.createElement( "table" )
    table.className = "reportCsvPreviewTable leave";
    let tBody = document.createElement( "tbody" )
    table.appendChild( tBody );

    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    let paramsBuilder = new CSVParametersBuilder().init()
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addUsersParam( reportParameters.userSelection, reportParamsStringBuilder );
    paramsBuilder.addLeavesParam( reportParameters.leaveTypeSelection, reportParamsStringBuilder );

    let parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum )

    parametersSection.addRows( tBody );
    header.addRows( tBody );
    dataGroupingSection.addRows(tBody);
    return table;
};


LeaveCSVPreviewGenerator.prototype.createPreviewStrategy = function ( reportParameters )
{
    switch ( reportParameters.columnsConfig )
    {
        case LeaveTypeColumnConfig.LEAVE_TIME_ONLY:
            return new LeaveCSVPreviewLeaveTimeOnlyStrategy().init();
            break;
        case LeaveTypeColumnConfig.BALANCES_ONLY:
            return new LeaveCSVPreviewBalancesOnlyStrategy().init(reportParameters.balanceQualifier);
            break;
        case LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES:
            return new LeaveCSVPreviewTimeAndBalancesStrategy().init(reportParameters.balanceQualifier);
            break;
        }
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewGenerator.js